import { CustomExtender } from '#/CoreFrameInterfaces';

export default class OverwritableExtender implements CustomExtender {

    public  AddToKnockout() {
        ko.extenders.overwritable = (target) => {
            if (ko.isWriteableObservable(target)) {
                return target;
            }

            let overwrittenValue = ko.observable();

            return ko.pureComputed({
                read: () => {
                    let computed = (target as any)();
                    let overwritten = overwrittenValue();

                    if (overwritten != null) {
                        return overwritten;
                    } else {
                        return computed;
                    }
                },
                write: (value) => {
                    overwrittenValue(value);
                }
            });
        };
    }

};